<md-content-box>
	<div class="grades-content">
		<md-icon icon="untitled-ui/education/graduation-hat-01"></md-icon>

		<div class="grades-body">

			@if ( semesters().length) {
				<div class="grades-table" [style.grid-template-columns]="gridTemplateColumns()">
					<!-- Header row -->
					<div class="grades-table__row grades-table__row--header">
						@if (showSemesterColumn()) {
							<div class="grades-table__cell grades-table__cell--semester"></div>
						}
						@for (col of categoryColumns(); track col.categoryID) {
							<div class="grades-table__cell">
								<span class="md-text-sm-medium">{{ col.categoryName }}</span>
							</div>
						}
						<div class="grades-table__cell grades-table__cell--final">
							<span class="md-text-sm-medium">Final</span>
						</div>
						@if (canEdit()) {
							<div class="grades-table__cell grades-table__cell--actions"></div>
						}
					</div>

					<!-- Semester rows -->
					@for (semester of semesters(); track semester.semesterNumber) {
						<div class="grades-table__row">
							@if (showSemesterColumn()) {
								<div class="grades-table__cell grades-table__cell--semester">
									@if (semester.levelName) {
										<span class="md-text-sm-semibold">{{ semester.levelName }}</span>
									} @else {
										<span class="md-text-sm-semibold">Semester {{ semester.semesterNumber }}</span>
									}
								</div>
							}

							@for (col of categoryColumns(); track col.categoryID) {
								@let cell = semester.categoryGrades[col.categoryID];
								<div class="grades-table__cell">
									@if (cell?.hasGrades) {
										<lb-grade-tag [compact]="true" [grade]="cell.gradeName ?? '—'" [type]="cell.color"></lb-grade-tag>
									} @else {
										<lb-grade-tag [compact]="true" grade="—" type="disabled"></lb-grade-tag>
									}
								</div>
							}

							<!-- Final column -->
							<div class="grades-table__cell grades-table__cell--final">
								@if (semester.finalGrade.hasGrades) {
									<div class="final-cell">
										<lb-grade-tag [compact]="true" [grade]="semester.finalGrade.gradeName ?? 'Submitted'" [type]="semester.finalGrade.color"></lb-grade-tag>
										<!-- Admin-only: an overridden final should not look identical to a calculated one to the
										person who can change it. The instructor and learner apps see the grade alone. -->
										@if (canEdit() && semester.finalGrade.isOverridden) {
											<md-tag
												class="override-tag"
												type="tertiary"
												[md-tooltip]="'Calculated grade: ' + (semester.finalGrade.calculatedGradeName ?? '—')"
												md-tooltip-position="bottom"
											>
												Overridden
											</md-tag>
										}
									</div>
								} @else {
									<lb-grade-tag [compact]="true" grade="—" type="disabled"></lb-grade-tag>
								}
							</div>

							<!-- Actions column (host capability): opens the Review & Submit Grades dialog for this semester
							whether or not grades have been submitted yet, and after the enrollment completes — but only once
							every lesson in the semester is complete, the same rule as the instructor's prompt. The API
							enforces both that rule and the re-submission entitlement, so this is a convenience, not the guard. -->
							@if (canEdit()) {
								<div class="grades-table__cell grades-table__cell--actions">
									@if (semester.semester.semesterID) {
										<button md-button (click)="editSemesterGrades.emit(semester.semester)" [disabled]="!semester.lessonsComplete" [attr.aria-label]="'Edit grades for ' + rowLabel(semester)">
											Edit
										</button>
									}
								</div>
							}
						</div>
					}
				</div>
			} @else {
				<span class="md-text-sm-regular no-value">No semester data available</span>
			}
		</div>
	</div>
</md-content-box>
